import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {getMarketplaces} from "../marketplace/marketplacesActions";
import utils from "../utils/utils";

const Shops = ({currentUser, marketplaces, loading, error, getMarketplaces}) => {

  useEffect(() => {
    getMarketplaces({
      userId: currentUser.id,
    });
  }, [currentUser, getMarketplaces]);

  return (
    <div className="shops">
      <div className="container">
        <h2 className="shops__title text-center">
          <FormattedMessage id={'my.marketplaces.header'}/>
        </h2>

        {loading? (
          <div className="text-center m-t-5 m-b-5">
            <div className="b-loader"/>
          </div>
        ): ''}

        {error? (
          <div className="alert alert-error m-t-5 m-b-5">
            {error}
          </div>
        ): ''}

        <div className="row">
            {marketplaces? marketplaces.map((marketplace, index) => {

            const imageStyles = {
              backgroundImage: marketplace.image? 'url("' + marketplace.image.mainImage + '")' :''
            };

            const company = marketplace.billDetails? marketplace.billDetails.className === 'CompanyBillDetails'?
              marketplace.billDetails.companyName: marketplace.billDetails.fullName: '-';

            return (
              <div className={utils.userIsAdmin(currentUser)? "col-12 col-sm-6 col-lg-4": "col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3"}>
                <Link key={index} to={'/marketplaceAdmin/' + marketplace.id}>
                  <div className="shops__marketplace m-b-2" style={imageStyles}>
                    <div className="shops__marketplace-overlay"/>
                    <div className="shops__marketplace-content">
                      <h3 className="shops__marketplace-content-name m-b-1">
                        {marketplace.name}
                      </h3>
                      <div>
                        {company}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          }): ''}

          {marketplaces && marketplaces.length === 0? (
            <p>
              <FormattedMessage id={'my.marketplaces.no.shops'}/>
              <br/>
              <br/>
              <Link className="btn btn-primary" to="/marketplace/create">
                <FormattedMessage id={'my.marketplaces.no.shops.cta'}/>
              </Link>
            </p>
          ): ''}
        </div>
      </div>
    </div>
  );
}

Shops.propTypes = {
  currentUser: PropTypes.object,
  marketplaces: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

Shops.defaultProps = {
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
    marketplaces: state.marketplaces.marketplaces,
    loading: state.marketplaces.loading,
    error: state.marketplaces.error,
  };
}

const mapDispatchToProps = {
  getMarketplaces,
};

export default connect(mapStateToProps, mapDispatchToProps)(Shops);